/*
 * WARNING!
 * Content of this file was for automatically generated (with `./bin/build-entries.js`).
 * All changes will be replaced.
 */
/* Libraries */
import './vendors/_bootstrap-experimental.scss';
import './vendors/_font-awesome.scss';

import './vendors/_lazysizes';
import './vendors/_picturefill';

/* Common components */
import './components/stat/stat.js';
import './components/clickout/clickout.js';
import './../../Schnaeppchenfuchs/assets/components/buttons/buttons.js';

/* Layout */

import './../../Schnaeppchenfuchs/assets/components/layout-header-admin/layout-header-admin.scss';
import './../../Schnaeppchenfuchs/assets/components/layout-header-desktop/layout-header-desktop.js';
import './../../Schnaeppchenfuchs/assets/components/layout-header-mobile/layout-header-mobile.js';
import './../../Schnaeppchenfuchs/assets/components/layout-menu/layout-menu.js';
import './../../Schnaeppchenfuchs/assets/components/layout-menu-shops/layout-menu-shops.scss';
import './../../Schnaeppchenfuchs/assets/components/layout-menu-categories/layout-menu-categories.scss';
import './../../Schnaeppchenfuchs/assets/components/layout-menu-tiles/layout-menu-tiles.scss';

import './../../Schnaeppchenfuchs/assets/components/layout-breadcrumb/layout-breadcrumb.scss';
import './../../Schnaeppchenfuchs/assets/components/layout-footer/layout-footer.scss';
import './../../Schnaeppchenfuchs/assets/components/layout-sidebar/layout-sidebar.js';

import './../../Schnaeppchenfuchs/assets/components/promo/promo.js';

import './components/page-header/page-header.scss';

import './../../Schnaeppchenfuchs/assets/components/flash-message/flash-message.js';

/* Components */
import './components/badge/badge.scss';

import './../../Schnaeppchenfuchs/assets/components/lightbox/lightbox.js';

import './components/load-more-page/load-more-page.js';


import './../../Schnaeppchenfuchs/assets/components/offers-label/offers-label.scss';

import './../../Schnaeppchenfuchs/assets/components/offers-label/_type_secondary/offers-label_type_secondary.scss';

import './../../Schnaeppchenfuchs/assets/components/offers-list-item-secondary/offers-list-item-secondary.scss';
import './components/offers-list-item-tertiary/offers-list-item-tertiary.scss';

import './../../Schnaeppchenfuchs/assets/components/posts-list-item-primary/posts-list-item-primary.scss';
import './components/rating/rating.js';
import './components/offers-voting/offers-voting.js';
import './components/page-offers-view/page-offers-view.js';
import './../../Schnaeppchenfuchs/assets/components/deals-category/deals-category.scss';
import './../../Schnaeppchenfuchs/assets/components/deals-like-button/deals-like-button.js';
import './../../Schnaeppchenfuchs/assets/components/deals-sharing/deals-sharing.js';

import './../../Schnaeppchenfuchs/assets/components/deals-list-item-secondary/deals-list-item-secondary.scss';
import './components/shops-card/shops-card.scss';

import './../../Schnaeppchenfuchs/assets/components/shops-list-item-primary/shops-list-item-primary.scss';

import './components/shops-description-headlines/shops-description-headlines.js';
import './../../Schnaeppchenfuchs/assets/components/teaser/teaser.js';
import './../../Schnaeppchenfuchs/assets/components/trimexa-ads/trimexa-ads.scss';
import './../../Schnaeppchenfuchs/assets/components/wysiwyg-content/wysiwyg-content.scss';
import './../../Schnaeppchenfuchs/assets/components/wysiwyg-accordion/wysiwyg-accordion.js';
import './../../Schnaeppchenfuchs/assets/components/wysiwyg-text-box/wysiwyg-text-box.js';
import './../../Schnaeppchenfuchs/assets/components/wysiwyg-rating/wysiwyg-rating.scss';
import './../../Schnaeppchenfuchs/assets/components/wysiwyg-newsletter/wysiwyg-newsletter.js';
import './../../Schnaeppchenfuchs/assets/components/layout-description/layout-description.js';
import './components/offers-list-tertiary/offers-list-tertiary.scss';
import './components/shops-top-offers-table/shops-top-offers-table.scss';
import './../../Schnaeppchenfuchs/assets/components/shops-deals/shops-deals.scss';
import './../../Schnaeppchenfuchs/assets/components/scroll-up-button/scroll-up-button.js';
import './components/shops-offers-list/shops-offers-list.js';
import './../../Schnaeppchenfuchs/assets/components/shops-filters-panel/shops-filters-panel.js';
import './components/offers-statistics/offers-statistics.scss';

import './components/offers-highlight-fixed/offers-highlight-fixed.js';
import './../../Schnaeppchenfuchs/assets/components/ads-banner/ads-banner.js';

/* Pages */
import './../../Schnaeppchenfuchs/assets/components/page-shops-view/page-shops-view.js';
